import { Auth } from 'aws-amplify'
import { useEffect, useState } from 'react'
import QRCode from 'react-qr-code'
import { settings } from '../../../../main/configs/settings'
import ClippingIcon from '../../../assets/icons/svgComponents/clipping-icon'
import Button from '../../button'
import Table from '../../table'
import * as S from './styles'
type Props = {
  disable: boolean
  page: number
  setPage: (page: number) => void
  fileName?: string
  cdBloco: string
  cdPsicologo: string
  uploads?: any
  handleSave: () => void
  columns: {
    Header: string
    accessor: string
  }[]
  data: {
    format: any
    description: any
    uploadDate: string
  }[]
  handleFileChange: (e: any) => void
  setTitle: (p: string) => void
}
const ImportFileModal = ({
  page,
  setPage,
  fileName,
  cdBloco,
  cdPsicologo,
  handleSave,
  columns,
  data,
  handleFileChange,
  setTitle,
  disable
}: Props) => {
  const [token, setToken] = useState<string>()
  useEffect(() => {
    ;(async () => {
      const auth: any = await Auth.currentSession()
      setToken(auth?.idToken?.jwtToken)
    })()
  }, [])
  const containers = [
    <S.MainWrapper className="main">
      <S.FilesContainer>
        <Table
          onClick={() => ({})}
          columns={columns}
          dataTable={data || []}
          handlePageClick={(currentPage: any) =>
            setPage(currentPage.selected + 1)
          }
          pageCount={1}
        />
      </S.FilesContainer>
      <S.ButtonsContainer>
        <Button onClick={() => setPage(2)}>Importar do arquivo</Button>
        <Button
          onClick={() => {
            setPage(1)
            setTitle('Importar pelo celular')
          }}
        >
          Importar pela câmera do celular
        </Button>
      </S.ButtonsContainer>
    </S.MainWrapper>,
    <S.PhoneInputWrapper className="import-on-phone">
      <label>Aponte a câmera do celular para o QR code abaixo</label>
      <QRCode
        value={`${settings.APP_URL}/importar-arquivo/${cdBloco}/${cdPsicologo}#${token}`}
        size={500}
        style={{ height: 'auto', maxWidth: '100%' }}
      />
    </S.PhoneInputWrapper>,
    <S.ComputerInputWrapper className="import-on-pc">
      <input
        type="file"
        onChange={(e) => {
          handleFileChange(e)
        }}
        id="file"
        className="inputfile"
      ></input>
      <label htmlFor="file">
        <ClippingIcon /> {fileName || 'Escolha um arquivo'}
      </label>
      <Button disabled={disable} onClick={() => handleSave()}>
        Salvar
      </Button>
    </S.ComputerInputWrapper>
  ]

  return containers[page]
}
export default ImportFileModal
